import React, { Component } from 'react';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxSalariesScribaNet extends Component {

    static defaultProps = {
        label: "Assigné à",
        placeholder: "Assigné à",
    };

    render = () => {

        const fetchMethod = () => new Promise((resolve, reject) => {
            const options = [
                { key: "AF", text: "Alexandre F." },
                { key: "BL", text: "Bastien L." },
                { key: "FP", text: "François P." },
                { key: "GJ", text: "Grégory J." },
                { key: "KP", text: "Kévin P." },
                { key: "MG", text: "Mehri G." },
                { key: "YD", text: "Yannick D." },
                { key: "MB", text: "Matthieu B." },
                { key: "PC", text: "Pris en Compte" }
            ];
            resolve({ codeRetour: 0, reponseAPIobjet: options });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            idValeurParDefaut="0"
        />;

    };

};